import React from 'react';
import { useStore } from '../../../../../store';
import { FormSelect } from '../../../../../../../../components/form';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export const DocumentHeaderSelect = ({ name, required }) => {
    const { t } = useTranslation();

    const {
        legalEntities: { legalEntities }
    } = useStore();

    const options = legalEntities?.map(it => {
        return { value: it.id, text: it.name };
    });

    return (
        <FormSelect
            name={name}
            required={required}
            label={t('sauron.financeModule.payoutProfiles.drawer.fields.documentHeader.label')}
            placeholder={t('sauron.financeModule.payoutProfiles.drawer.fields.documentHeader.placeholder')}
            options={options}
        />
    );
};

DocumentHeaderSelect.propTypes = {
    name: PropTypes.string.isRequired,
    required: PropTypes.bool
};
